<template>
  <v-card outlined class="mb-4 pa-3">
    <PhotoPicker v-model="photo" :src="item.path" />

    <v-textarea
      v-model="description"
      class="mt-3"
      label="Descreva a imagem do dano*"
      placeholder="Ex: Dano na parede da cozinha causada por infiltração."
      outlined
      dense
      auto-grow
      rows="3"
      :color="insurer.color"
    />

    <v-btn
      text
      small
      color="red"
      class="mt-2"
      @click="$emit('remove', item.id)"
    >
      Remover
    </v-btn>
  </v-card>
</template>

<script>
import PhotoPicker from "@/components/customers/PhotoPicker.vue";
import { returnPathImages } from "@/services/customer_inbound";

export default {
  name: "DamageItem",
  components: { PhotoPicker },

  props: {
    item: { type: Object, required: true },
    insurer: Object,
  },

  data() {
    return {
      photo: null, // File (quando usuário troca)
      description: this.item.description || "",
      uploading: false,
    };
  },

  watch: {
    async photo(file) {
      if (!file) return;

      this.uploading = true;

      try {
        const result = await returnPathImages([file]);
        const path = result?.paths?.[0];

        if (!path) throw new Error("Path da imagem não retornado");

        this.$emit("update", {
          ...this.item,
          path,
        });
      } catch (e) {
        console.error("Erro ao enviar imagem", e);
      } finally {
        this.uploading = false;
        this.photo = null; // limpa file após upload (opcional)
      }
    },

    description(value) {
      this.$emit("update", {
        ...this.item,
        description: value,
      });
    },
  },
};
</script>
